import styles from './PageProductFooter.module.css';
import Link from './Link.js';

function PageProductFooter() {
  return (
    <footer className={styles.PageProductFooter}>
      <span className={styles.questions}>Have questions?&nbsp;</span>
      <Link
        color="#0477C9"
        to="https://cnbc.zendesk.com/hc/en-us/"
        letterSpacing="0.03px"
      >
        Click here for FAQs
      </Link>
      <span className={styles.or}>or</span>
      <Link
        color="#0477C9"
        to="https://help.cnbc.com/contact/"
        letterSpacing="0.03px"
      >
        Contact a Customer Care Rep
      </Link>
    </footer>
  );
}

export default PageProductFooter;
